import { sha256 } from 'js-sha256';

/**
 * Canonical growth event names for server-side deduplication.
 * Must match svc-growth-events model.EventName constants exactly.
 *
 * Natural keys per event:
 *   signup              → user_id
 *   signup_kyc_approved → user_id
 *   deposit             → deposit_id
 *   deposit_first       → deposit_id
 *   trade               → trade_id (order_id)
 *   trade_first         → trade_id (order_id)
 */
export const GrowthEvent = {
    Signup: 'signup',
    KYCApproved: 'signup_kyc_approved',
    Deposit: 'deposit',
    FirstDeposit: 'deposit_first',
    Trade: 'trade',
    FirstTrade: 'trade_first',
} as const;

export type GrowthEventName = (typeof GrowthEvent)[keyof typeof GrowthEvent];

/**
 * Generate a deterministic event ID for partner deduplication (Meta, Google, TikTok, AppsFlyer).
 *
 * Formula: hex(SHA-256(naturalKey + eventName))
 *
 * This must match the server-side GenerateEventID in svc-growth-events exactly so that
 * client-fired events and server-fired events share the same event_id for dedup.
 */
export const growthEventId = (naturalKey: string, eventName: GrowthEventName): string => {
    return sha256(naturalKey + eventName);
};
